import type { NavLinkProps } from 'react-router-dom'
import { NavLink } from 'react-router-dom'

export default function ReloaderNavlink(props: NavLinkProps) {
  return (
    <NavLink
      {...props}
      state={{
        clickedAt: Date.now(),
      }}
    />
  )
}
